export default __webpack_public_path__ + "static/media/logo-full-pink.85c71a23.svg";